import { type StateCreator, create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { AppendixRow } from '@repo/types/docusign';

interface DocusignState {
    mode: 'status' | 'new';
    selectedRequestTemplates: string[];
    setSelectedRequestTemplates: (selectedRequestTemplates: string[]) => void;
    setMode: (mode: 'status' | 'new') => void;
    email: string;
    setEmail: (email: string) => void;
    appendixFiles: AppendixRow[];
    setAppendixFiles: (appendixFiles: AppendixRow[]) => void;
}

const createDocusignIndexStore: StateCreator<DocusignState, [['zustand/devtools', never]], [], DocusignState> = (
    set
) => ({
    selectedRequestTemplates: [],
    setSelectedRequestTemplates: (selectedRequestTemplates: string[]) => {
        set({ selectedRequestTemplates });
    },
    email: '',
    setEmail: (email: string) => {
        set({ email });
    },
    mode: 'status',
    setMode: (mode: 'status' | 'new') => {
        set({ mode });
    },
    appendixFiles: [],
    setAppendixFiles: (appendixFiles: AppendixRow[]) => {
        set({ appendixFiles });
    },
});

export const useSignaturesIndexStore = create<DocusignState>()(
    devtools(createDocusignIndexStore, { name: 'docusign-index-store' })
);
